import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from 'vue-meta'
import { get_auth_cookie, get_cookie, remove_auth_cookie } from "../helpers/auth";

Vue.use(VueMeta)
Vue.use(VueRouter);

const router = new VueRouter({
  base: '/web',
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  if(get_cookie('Client')){
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      remove_auth_cookie();
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
  }
  let isAuthenticated = get_auth_cookie() ? true : false;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
